import { render, staticRenderFns } from "./DeadlineDetailCard.vue?vue&type=template&id=13765658"
import script from "./DeadlineDetailCard.vue?vue&type=script&lang=js"
export * from "./DeadlineDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports